import PartnerBtnCN from '../Powerocean/components/PartnerBtnCN';
import BlackoutProtection from './components/BlackoutProtection';
import Disclaimer from './components/Disclaimer';
import Effortlessly from './components/Effortlessly';
import EnergyHousekeeper from './components/EnergyHousekeeper';
import FirstKV from './components/FirstKV';
import MountingOptions from './components/MountingOptions';
import Nav from './components/Nav';
import ProductAnimation from './components/ProductAnimation';
import ProductIntroduction from './components/ProductIntroduction';
import SeamlessUpdates from './components/SeamlessUpdates';
import SleekDesign from './components/SleekDesign';
import Solution from './components/Solution';
import WeatherResistant from './components/WeatherResistant';

export default function IndexDynamic() {
    return (
        <>
            <Nav />
            <FirstKV />
            <ProductIntroduction />
            <ProductAnimation />
            <Solution />
            <SleekDesign />
            <Effortlessly />
            <MountingOptions />
            <WeatherResistant />
            <BlackoutProtection />
            <SeamlessUpdates />
            <EnergyHousekeeper />
            <PartnerBtnCN />
            <Disclaimer />
        </>
    );
}
